import React from 'react';
import { CTAButton } from './CTAButton';
export function CloserSection() {
  return <section className="relative min-h-[80vh] flex items-center justify-center py-[100px] px-5 text-center overflow-hidden" data-id="element-121">
      {/* Background image with dark overlay */}
      <div className="absolute inset-0 z-0" data-id="element-122">
        <img src="https://cdn.magicpatterns.com/uploads/ss2rLyt13pTtTUnmdrYgSE/heylloyd-image-1774832280250.png" alt="" className="w-full h-full object-cover" data-id="element-123" />
        <div className="absolute inset-0" style={{
        background: 'linear-gradient(160deg, rgba(15,35,24,0.92) 0%, rgba(26,58,42,0.88) 100%)'
      }} data-id="element-124" />
      </div>

      <div className="relative z-10 max-w-[800px] mx-auto" data-id="element-125">
        <p className="font-sans text-[11px] font-bold text-gold-accent tracking-[0.4em] uppercase mb-6" data-id="element-126">
          THIS IS THE MOMENT
        </p>

        <h2 className="font-serif text-[42px] md:text-[68px] text-cream-light leading-[1.1] mb-10" data-id="element-127">
          The Gas Moment
          <br data-id="element-128" />
          Ends Tonight.
          <br data-id="element-129" />
          <span className="italic text-gold-accent mt-2 block" data-id="element-130">
            The System Starts Now.
          </span>
        </h2>

        <div className="font-sans text-[19px] text-cream-light/80 max-w-[640px] mx-auto leading-[2.1] mb-12" data-id="element-131">
          <p className="mb-6" data-id="element-132">
            You've done the math in your head a hundred times.
            <br data-id="element-133" />
            You've told yourself it would get better when you got a raise.
            <br data-id="element-134" />
            When the car was paid off.
            <br data-id="element-135" />
            When things slowed down.
          </p>
          <p className="font-bold text-cream-light mb-8" data-id="element-136">
            It hasn't gotten better.
            <br data-id="element-137" />
            Not because you're not trying.
            <br data-id="element-138" />
            Not because you don't care.
            <br data-id="element-139" />
            Because you've been trying to solve a systems problem with
            willpower.
          </p>
          <p className="font-serif italic text-[24px] text-gold-accent" data-id="element-140">
            You don't need more discipline.
            <br data-id="element-141" />
            You need a system.
            <br data-id="element-142" />
            This is the system.
          </p>
        </div>

        <div className="mb-6" data-id="element-143">
          <CTAButton className="text-[20px] tracking-[0.08em] px-[60px] py-[22px]" data-id="element-144">
            GET THE DEBT-FREE SYSTEM — $9.99
          </CTAButton>
        </div>

        <p className="font-sans text-[13px] text-cream-light/60 mb-6 max-w-[400px] mx-auto" data-id="element-145">
          Instant PDF download · All 19 tools included
          <br data-id="element-146" />
          Chapter 5 money-back guarantee · Start in 5 minutes · Keep forever
        </p>

        <p className="font-sans text-[12px] text-cream-light/60 mb-16" data-id="element-147">
          🔒 Secure · 📥 Instant · 💰 Guaranteed · ♾️ Yours Forever
        </p>

        <p className="font-serif italic text-[24px] md:text-[28px] text-gold-accent max-w-[600px] mx-auto" data-id="element-148">
          "I am not someone who hopes debt goes away.
          <br data-id="element-149" />I am someone with a system."
        </p>
      </div>
    </section>;
}